import { render, staticRenderFns } from "./SellPlanWorkspace.vue?vue&type=template&id=70f71d56&scoped=true"
import script from "./SellPlanWorkspace.vue?vue&type=script&lang=ts"
export * from "./SellPlanWorkspace.vue?vue&type=script&lang=ts"
import style0 from "./SellPlanWorkspace.vue?vue&type=style&index=0&id=70f71d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f71d56",
  null
  
)

export default component.exports